module.exports = __webpack_public_path__ + "static/img/Quality page top img_mobile.4c4a06cf.jpg";